/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS python filter api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GroundingSchema,
  HTTPValidationError,
  PageGroundingSchema,
} from '../models';
import {
    GroundingSchemaFromJSON,
    GroundingSchemaToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    PageGroundingSchemaFromJSON,
    PageGroundingSchemaToJSON,
} from '../models';

export interface ReadGroundingGroundingsIdGetRequest {
    id: number;
}

export interface ReadGroundingsGroundingsGetRequest {
    startDatetime?: Date | null;
    endDatetime?: Date | null;
    page?: number;
    size?: number;
}

export interface ReadGroundingsMmsiGroundingsMmsiMmsiGetRequest {
    mmsi: number;
    page?: number;
    size?: number;
}

/**
 * 
 */
export class GroundingsApi extends runtime.BaseAPI {

    /**
     * Get a single grounding by ID. Args:     id (int): The ID of the grounding     db (Session): The database session     username (str): The username of the authenticated user Returns:     Instance of the Grounding
     * Read Grounding
     */
    async readGroundingGroundingsIdGetRaw(requestParameters: ReadGroundingGroundingsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroundingSchema>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readGroundingGroundingsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/groundings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroundingSchemaFromJSON(jsonValue));
    }

    /**
     * Get a single grounding by ID. Args:     id (int): The ID of the grounding     db (Session): The database session     username (str): The username of the authenticated user Returns:     Instance of the Grounding
     * Read Grounding
     */
    async readGroundingGroundingsIdGet(requestParameters: ReadGroundingGroundingsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroundingSchema> {
        const response = await this.readGroundingGroundingsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all groundings for a user (and their group). Optionally within the given time range. Args:     start_datetime (datetime): The start time of the range     end_datetime (datetime): The end time of the range     db (Session): The database session     username (str): The username of the authenticated user Returns:     List of Grounding instances
     * Read Groundings
     */
    async readGroundingsGroundingsGetRaw(requestParameters: ReadGroundingsGroundingsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageGroundingSchema>> {
        const queryParameters: any = {};

        if (requestParameters.startDatetime !== undefined) {
            queryParameters['start_datetime'] = (requestParameters.startDatetime as any).toISOString();
        }

        if (requestParameters.endDatetime !== undefined) {
            queryParameters['end_datetime'] = (requestParameters.endDatetime as any).toISOString();
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/groundings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageGroundingSchemaFromJSON(jsonValue));
    }

    /**
     * Get all groundings for a user (and their group). Optionally within the given time range. Args:     start_datetime (datetime): The start time of the range     end_datetime (datetime): The end time of the range     db (Session): The database session     username (str): The username of the authenticated user Returns:     List of Grounding instances
     * Read Groundings
     */
    async readGroundingsGroundingsGet(requestParameters: ReadGroundingsGroundingsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageGroundingSchema> {
        const response = await this.readGroundingsGroundingsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all groundings for a specific MMSI. Args:     mmsi (int): The MMSI of the vessel     db (Session): The database session     username (str): The username of the authenticated user Returns:     Page of Grounding instances
     * Read Groundings Mmsi
     */
    async readGroundingsMmsiGroundingsMmsiMmsiGetRaw(requestParameters: ReadGroundingsMmsiGroundingsMmsiMmsiGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageGroundingSchema>> {
        if (requestParameters.mmsi === null || requestParameters.mmsi === undefined) {
            throw new runtime.RequiredError('mmsi','Required parameter requestParameters.mmsi was null or undefined when calling readGroundingsMmsiGroundingsMmsiMmsiGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/groundings/mmsi/{mmsi}`.replace(`{${"mmsi"}}`, encodeURIComponent(String(requestParameters.mmsi))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageGroundingSchemaFromJSON(jsonValue));
    }

    /**
     * Get all groundings for a specific MMSI. Args:     mmsi (int): The MMSI of the vessel     db (Session): The database session     username (str): The username of the authenticated user Returns:     Page of Grounding instances
     * Read Groundings Mmsi
     */
    async readGroundingsMmsiGroundingsMmsiMmsiGet(requestParameters: ReadGroundingsMmsiGroundingsMmsiMmsiGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageGroundingSchema> {
        const response = await this.readGroundingsMmsiGroundingsMmsiMmsiGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
